export const SCROLL_THROTTLE_DELAY = 100;
export const RESIZE_THROTTLE_DELAY = 100;
export const SCROLL_ANIMATION_DELAY = 300;
export const VERTICAL_VISIBLE_INDENT = 40;
export const SCROLL_CLICK_DEAD_ZONE = 2;
